// @flow
import { CustomMessagesReader, type Chunk } from './CustomMessagesReader';
import { CastReceiver } from '.';

class CustomPartialMessagesManager {
  /** Pool of readers to read messages with different ID separately. */
  readers: { [key: string]: CustomMessagesReader } = {};

  readChunk(chunk: Chunk): boolean {
    const { id } = chunk;
    let reader = this.readers[id];

    if (!reader) {
      reader = new CustomMessagesReader(chunk);
      this.readers[id] = reader;
      CastReceiver.log('[CAST] Creating reader', id);
    }

    return reader.append(chunk);
  }

  releaseReaderById(id: string) {
    CastReceiver.log(`[CAST] Releasing reader ${id}`);
    delete this.readers[id];
  }

  getFullPayloadByMessageId(id: string, releaseReaderAfterRead: boolean = true): ?Object {
    const reader = this.readers[id];
    if (!reader) {
      console.error(`CustomMessagesManager.getFullPayload can't find reader with ID ${id}`);
      return null;
    }

    if (reader.hasFullPayload() === false) {
      console.error(
        `CustomMessagesManager.getFullPayload - reader ${id} doesn't have the full payload yet.`,
      );
      return null;
    }

    const payload = reader.getFullPayload();
    CastReceiver.log(`[CAST] Received full payload for ${id}`);

    if (releaseReaderAfterRead) this.releaseReaderById(id);

    return payload;
  }
}

export { CustomPartialMessagesManager };
